
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersNight as ObiLightningLightSleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-night.js';
 
 
 

 
 export const ObiLightningLightSleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-night',
   elementClass: ObiLightningLightSleetShowersNightElement,
   events: {
     
   }
  });
 
 